import { LanguageSelector } from "@/components/organisms/language-selector";

interface GamifikTopBarProps {
  children?: React.ReactNode;
}

export function GamifikTopBar({ children }: GamifikTopBarProps) {
  return (
    <header className="shrink-0 shadow-md bg-card z-40" style={{ fontFamily: "var(--font-turmas-sora, 'Sora', sans-serif)" }}>
      <div className="mx-auto w-full max-w-[1440px] px-4 sm:px-6">
        <div className="flex min-h-14 flex-wrap items-center justify-between gap-y-1.5 py-2 sm:h-14 sm:flex-nowrap sm:py-0">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img src="/images/gamefik-logo.png" alt="Gamefik" className="h-7 w-7" />
            <span className="text-sm font-semibold text-foreground">Gamefik</span>
          </div>

          {/* Middle slot (optional) */}
          {children && (
            <nav className="order-last flex w-full items-center rounded-lg border border-border bg-muted/50 p-1 sm:order-none sm:w-auto">
              {children}
            </nav>
          )}

          {/* Language selector */}
          <LanguageSelector />
        </div>
      </div>
    </header>
  );
}
